import Group, { GroupItem } from './Group'
import { Divider } from 'theme-ui'
import TextWithOverFlowAndTippyPopup from 'components/TextWithOverFlowAndTippyPopup'
import React, { ReactElement } from 'react'
import { LatencyStatus, notAvailable, ResolverType } from './index'
import { DetectionInfo, IP } from 'store/api/configurationStatus'
import LoadingPlaceholder from './LoadingPlaceholder'
import useGetColorMode from 'utils/useGetColorMode'
import { TextWithBreakpointVariant } from 'ui/TextWithBreakpointVariant'

export default function DnsGroup({
  ipControlD,
  detectionInfo,
  dnsLatency,
  dnsHost,
  dnsIp,
  isDetectionInfoLoading,
  isDnsLatencyLoading,
  isDnsLatencyLoading2,
  isIpControlDLoading,
}: {
  ipControlD?: IP
  detectionInfo?: DetectionInfo
  dnsLatency: string
  dnsHost: string
  dnsIp: string
  isDetectionInfoLoading: boolean
  isDnsLatencyLoading: boolean
  isDnsLatencyLoading2: boolean
  isIpControlDLoading: boolean
}): ReactElement {
  const { isLightMode } = useGetColorMode()

  return (
    <Group
      title="DNS"
      badgeText={ipControlD ? 'Using Control D' : 'Not Using Control D'}
      isSuccess={!!ipControlD}
      isLoading={isIpControlDLoading}
    >
      <GroupItem>
        <TextWithBreakpointVariant variant={['size14Weight600Line138', 'size15Weight700Line138']}>
          Resolver
        </TextWithBreakpointVariant>
        <LoadingPlaceholder isLoading={isIpControlDLoading || isDetectionInfoLoading}>
          <TextWithBreakpointVariant
            variant={['size12Weight400Line138', 'size15Weight400Line138']}
            sx={{
              overflowWrap: ['break-word', 'normal'],
            }}
          >
            {detectionInfo?.uid
              ? `${detectionInfo?.uid}${detectionInfo?.device ? `:${detectionInfo?.device}` : ''}`
              : notAvailable}
          </TextWithBreakpointVariant>
        </LoadingPlaceholder>
      </GroupItem>
      <Divider sx={{ width: '100%', height: '1px', color: 'lightSkyBlue10' }} />
      <GroupItem>
        <TextWithBreakpointVariant variant={['size14Weight600Line138', 'size15Weight700Line138']}>
          Protocol
        </TextWithBreakpointVariant>
        <LoadingPlaceholder isLoading={isIpControlDLoading || isDetectionInfoLoading}>
          <TextWithBreakpointVariant variant={['size12Weight400Line138', 'size15Weight400Line138']}>
            {detectionInfo?.protocol ? ResolverType[detectionInfo?.protocol] : notAvailable}
          </TextWithBreakpointVariant>
        </LoadingPlaceholder>
      </GroupItem>
      <Divider sx={{ width: '100%', height: '1px', color: 'lightSkyBlue10' }} />
      <GroupItem>
        <TextWithBreakpointVariant variant={['size14Weight600Line138', 'size15Weight700Line138']}>
          {ipControlD ? 'Latency' : 'Expected Latency'}
        </TextWithBreakpointVariant>
        <LoadingPlaceholder
          isLoading={isIpControlDLoading || isDnsLatencyLoading || isDnsLatencyLoading2}
        >
          <LatencyStatus latency={dnsLatency} />
        </LoadingPlaceholder>
      </GroupItem>
      <Divider sx={{ width: '100%', height: '1px', color: 'lightSkyBlue10' }} />
      <GroupItem>
        <TextWithBreakpointVariant variant={['size14Weight600Line138', 'size15Weight700Line138']}>
          Host
        </TextWithBreakpointVariant>
        <LoadingPlaceholder
          isLoading={isIpControlDLoading || isDnsLatencyLoading || isDnsLatencyLoading2}
        >
          <TextWithBreakpointVariant variant={['size12Weight400Line138', 'size15Weight400Line138']}>
            {dnsHost || notAvailable}
          </TextWithBreakpointVariant>
        </LoadingPlaceholder>
      </GroupItem>
      <Divider sx={{ width: '100%', height: '1px', color: 'lightSkyBlue10' }} />
      <GroupItem>
        <TextWithBreakpointVariant
          variant={['size14Weight600Line138', 'size15Weight700Line138']}
          sx={{ display: 'inline-flex', flexShrink: 0, mr: '0.8rem' }}
        >
          IP
        </TextWithBreakpointVariant>
        <LoadingPlaceholder
          isLoading={isIpControlDLoading || isDnsLatencyLoading || isDnsLatencyLoading2}
        >
          <TextWithOverFlowAndTippyPopup
            theme={isLightMode ? 'light-org-tooltip' : 'org-tooltip'}
            variant={['size12Weight400Line138', 'size15Weight400Line138']}
            content={dnsIp || notAvailable}
            ariaLabel={dnsIp || notAvailable}
          />
        </LoadingPlaceholder>
      </GroupItem>
    </Group>
  )
}
